import React, { useState } from "react";
import { Mail, User, Smartphone, FileText } from "lucide-react";
import styles from "./Contact.module.css";

const ContactComponent: React.FC = () => {
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSuccess(false);
    setError(false);

    try {
      setTimeout(() => {
        setSuccess(true);
        setIsSubmitting(false);
        setFormData({
          fullName: "",
          email: "",
          phone: "",
          subject: "",
          message: "",
        });
      }, 2000);
    } catch (err) {
      setError(true);
      setIsSubmitting(false);
    }
  };

  return (
    <div className="px-4">
      <section className={styles.contactContainer}>
        <h3 className={styles.contactSubtitle}>Contactez-nous</h3>
        <h2 className={styles.contactTitle}>
          Prêts à transformer la gestion du cheptel au Sénégal ?
        </h2>

        <form className={styles.formFields} onSubmit={handleSubmit}>
          <div className={styles.formRow}>
            <div className={styles.inputGroup}>
              <input
                type="text"
                name="fullName"
                placeholder="Nom complet"
                value={formData.fullName}
                onChange={handleChange}
                required
              />
              <User className={styles.inputIcon} />
            </div>
            <div className={styles.inputGroup}>
              <input
                type="email"
                name="email"
                placeholder="Adresse email"
                value={formData.email}
                onChange={handleChange}
                required
              />
              <Mail className={styles.inputIcon} />
            </div>
          </div>

          <div className={styles.formRow}>
            <div className={styles.inputGroup}>
              <input
                type="text"
                name="phone"
                placeholder="Numéro de téléphone"
                value={formData.phone}
                onChange={handleChange}
                required
              />
              <Smartphone className={styles.inputIcon} />
            </div>
            <div className={styles.inputGroup}>
              <input
                type="text"
                name="subject"
                placeholder="Sujet"
                value={formData.subject}
                onChange={handleChange}
                required
              />
              <FileText className={styles.inputIcon} />
            </div>
          </div>

          <div className={styles.textareaContainer}>
            <textarea
              name="message"
              placeholder="Écrivez votre message ici"
              rows={4}
              value={formData.message}
              onChange={handleChange}
              required
            />
          </div>

          {success && (
            <p className={styles.successMessage}>
              Votre message a été envoyé avec succès !
            </p>
          )}
          {error && (
            <p className={styles.errorMessage}>
              Une erreur est survenue. Veuillez réessayer.
            </p>
          )}

          <div className={styles.buttonContainer}>
            <button
              type="submit"
              className={styles.contactSubmit}
              disabled={isSubmitting}
            >
              {isSubmitting ? "Envoi en cours..." : "Envoyer"}
            </button>
          </div>
        </form>
      </section>
    </div>
  );
};

export default ContactComponent;
